import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { useSliderNavigation } from '../../../slider'
import { urlResolverGetOffersCategoryPage } from '../../../url-handling'
import { contactPageAccessorGetUrlForOrderCard } from '../../contactPageAccessorGetUrlForOrderCard'

import { useContactPageLastOrderContext } from './ContactPageLastOrderContext'
import { ContactPageSliderControls } from './ContactPageSliderControls'
import { ContactPageSubOrderDetailsCard } from './ContactPageSubOrderDetailsCard'

export const ContactPageLastOrder: FC = () => {
  const config = useGlobalConfigContext()
  const { firstSubOrder, lastOrder } = useContactPageLastOrderContext()

  const { containerProps, leftRef, rightRef } =
    useSliderNavigation<HTMLUListElement>()

  return (
    <div className="flex w-full flex-col gap-6 tablet:mt-0">
      {lastOrder && firstSubOrder ? (
        <>
          <ul
            className="flex snap-x snap-mandatory flex-nowrap gap-4 overflow-x-auto scroll-smooth rounded-m bg-light-primary-medium scrollbar-hide"
            {...containerProps}
          >
            {lastOrder.subOrders?.map((subOrder) => (
              <li
                className="shrink-0 grow-0 basis-full snap-start"
                data-qa-id="qa-id-contact-page-last-order-sub-order-card"
                key={subOrder.subOrderId}
              >
                <ContactPageSubOrderDetailsCard
                  href={contactPageAccessorGetUrlForOrderCard(
                    config,
                    lastOrder,
                  )}
                  order={lastOrder}
                  subOrder={subOrder}
                />
              </li>
            ))}
          </ul>
          {lastOrder.subOrders && lastOrder.subOrders.length > 1 ? (
            <ContactPageSliderControls leftRef={leftRef} rightRef={rightRef} />
          ) : null}
        </>
      ) : (
        <div className="flex w-full flex-col gap-6 rounded-m border border-dark-primary-min px-4 py-6">
          <p className="w-full text-start text-s">
            <FormattedMessage id="contact.ordersSection.description.noOrder" />
          </p>
          <Button<'a'>
            className="w-full"
            href={urlResolverGetOffersCategoryPage(config)}
            size="medium"
            variant="filled"
          >
            <FormattedMessage id="contact.ordersSection.cta.findProductsLabel" />
          </Button>
        </div>
      )}
    </div>
  )
}
